import * as Sentry from '@sentry/browser'

import { DayOfWeekIndex } from 'modules/core/lib/dates'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

export default async function runI18nSetup(locale: string, firstDayOfWeek: DayOfWeekIndex) {
  Sentry.addBreadcrumb({
    category: 'i18n',
    message: `Locale '${locale}' not loaded yet`,
    level: 'info',
  })

  if (i18n.locale === locale) return

  await i18n.loadLocale(locale, firstDayOfWeek)

  // Set HTML lang
  const html = document.querySelector('html')

  if (html) html.setAttribute('lang', i18n.locale)

  const keys = Object.keys(i18n.translations[locale] || {})
  const message = `Locale '${locale}' successfully loaded. Top level keys: ${keys.length}`

  // Adds the Crowdin in-place translations overlay only when using Esperanto
  if (hasFeature('in_context_localization') && i18n.locale === 'eo') {
    const script = document.createElement('script')
    script.src = '//cdn.crowdin.com/jipt/jipt.js'
    script.async = true
    document.body && document.body.appendChild(script)
    window._jipt = [['project', 'factorial-frontend']]
  }

  // FIXME: Investigation in progress
  const startSample = `Start Sample: ${String(i18n.translations[locale]).slice(0, 150)}`

  const endSample = `End Sample: ${String(i18n.translations[locale]).slice(-150)}`
  Sentry.addBreadcrumb({
    category: 'i18n',
    message,
    level: 'info',
  })
  Sentry.addBreadcrumb({
    category: 'i18n',
    message: startSample,
    level: 'info',
  })
  Sentry.addBreadcrumb({
    category: 'i18n',
    message: endSample,
    level: 'info',
  })
}
